import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import SessionsDashboard from '../../../BreathworkHub/SessionsDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyBreathworkSessions } from './companyBreathworkApi';

/** Company Breathwork → Tracker Dashboard, scoped to this company. */
const CBreathworkSessions = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyBreathworkSessions(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Breathwork Tracker | Shoorah</title>
      </Helmet>
      <SessionsDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CBreathworkSessions;
